// src/components/FAQSection.js
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown'; // Import ReactMarkdown
import rehypeRaw from 'rehype-raw';         // Optional: if you need to render HTML within your Markdown
import './FAQSection.css';                 // Your existing CSS

const FAQSection = ({ faqs = [] }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faqSection">
      <h2 className="faqTitle">Frequently Asked Questions</h2>
      <div className="faqList">
        {faqs.map((faq, index) => (
          <div key={faq.id} className="faqItem">
            <button className="faqQuestion" onClick={() => toggleFAQ(index)}>
              {faq.question}
            </button>
            {openIndex === index && (
              <div className="faqAnswer">
                {/* Use ReactMarkdown to render the Markdown string */}
                {typeof faq.answer === 'string' && faq.answer.trim() !== '' ? (
                  <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                    {faq.answer}
                  </ReactMarkdown>
                ) : (
                  <p>No answer content available.</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;